export enum DOMAIN_TYPE {
  NATIONAL = 'national',
  BAC = 'bac',
}

export enum SCHEMA_TYPE {
  GENERAL = 'general',
  ARTICLE = 'article',
  MEDIA = 'media',
  EMAIL = 'email',
  CAREER = 'career',
}

export type ILANGUAGE = 'fr' | 'ar';

export enum LANGUAGE {
  ENGLISH = ' en',
  FRENCH = 'fr',
  ARABIC = 'ar',
}

export const NATIONAL_PAGES = {
  HOME: {
    VISION: 'home/vision',
    MISSION: 'home/mission',
    LABEL: 'home/label',
    TESTIMONIAL: 'home/testimonial',
    GALLERY: 'home/gallery',
  },
  ACADEMICS: {
    STAGES: {
      GENERAL: 'academics',
      KG: 'academics/stages/kg',
      PREPARATORY: 'academics/stages/preparatory',
      PRIMARY: {
        PRIMARY_SMALL: 'academics/stages/primary/small',
        PRIMARY_BIG: 'academics/stages/primary/big',
      },
      SECONDARY: 'academics/stages/secondary',
    },
    LIBRARY: {
      GENERAL: 'academics/library',
      AR: {
        GENERAL: 'academics/library/ar',
        KG: 'academics/library/ar/kg',
        PRIMARY: 'academics/library/ar/primary',
        PREPARATORY: 'academics/library/ar/preparatory',
        SECONDARY: 'academics/library/ar/secondary',
      },
      FR: {
        GENERAL: 'academics/library/fr',
        KG: 'academics/library/fr/kg',
        PRIMARY: 'academics/library/fr/primary',
        PREPARATORY: 'academics/library/fr/preparatory',
        SECONDARY: 'academics/library/fr/secondary',
      },
    },
    ALUMNI: {
      GENERAL: 'alumni',
      ARTICLES: 'alumni/articles',
    },
  },
  NEWS: 'news',
  ACTIVITIES: {
    GENERAL: 'activities',
    ART: {
      DRAW: 'activities/art/draw',
      MUSIC: 'activities/art/music',
    },
    SCOUTS: {
      SCOUT: 'activities/scouts/scout',
      MEJ: 'activities/scouts/mej',
    },
    SOCIAL: 'activities/social',
    SPORTS: 'activities/sports',
    THEATRE: 'activities/theatre',
  },
  MEDIA: {
    GENERAL: 'media',
    ARCHIVE: 'media/archive',
    PHOTO: 'media/photo',
    PRESS: 'media/press',
    RADIO: 'media/radio',
    VIDEO: 'media/video',
  },
  ABOUT: {
    GENERAL: 'about',
    HISTORY: 'about/history',
    TOUR: 'about/tour',
    PERSONAL: {
      STAFF: 'about/personal/staff',
      PHOTO: 'about/personal/photo',
      FORMATION: 'about/personal/formation',
    },
    PARTNERS: 'about/partners',
  },
  ADMISSION: 'admisison',
  CAREERS: 'careers',
  EMAIL: {
    NEWS_LETTER: 'email/newsLetter',
    CONTACT_US: 'email/contactUs',
  },
};

export const NATIONAL_SCHEMA_TYPES = {
  GENERAL: [
    // Home
    ...Object.values(NATIONAL_PAGES.HOME).map((val) => String(val)),
    // Academics
    NATIONAL_PAGES.ACADEMICS.STAGES.GENERAL,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.GENERAL,
    NATIONAL_PAGES.ACADEMICS.ALUMNI.GENERAL,
    // Activities
    NATIONAL_PAGES.ACTIVITIES.GENERAL,
    // Media
    NATIONAL_PAGES.MEDIA.GENERAL,
    NATIONAL_PAGES.ABOUT.GENERAL,
    // Admission
    NATIONAL_PAGES.ADMISSION,
    // Careers
    NATIONAL_PAGES.CAREERS,
  ],
  ARTICLE: [
    // Academics - Stages
    NATIONAL_PAGES.ACADEMICS.STAGES.KG,
    NATIONAL_PAGES.ACADEMICS.STAGES.PRIMARY.PRIMARY_SMALL,
    NATIONAL_PAGES.ACADEMICS.STAGES.PRIMARY.PRIMARY_BIG,
    NATIONAL_PAGES.ACADEMICS.STAGES.PREPARATORY,
    NATIONAL_PAGES.ACADEMICS.STAGES.SECONDARY,
    NATIONAL_PAGES.ACADEMICS.ALUMNI.ARTICLES,
    // Academics - Library
    NATIONAL_PAGES.ACADEMICS.LIBRARY.AR.KG,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.AR.PREPARATORY,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.AR.PRIMARY,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.AR.SECONDARY,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.KG,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.PREPARATORY,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.PRIMARY,
    NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.SECONDARY,
    // News
    NATIONAL_PAGES.NEWS,
    // Activities
    NATIONAL_PAGES.ACTIVITIES.ART.DRAW,
    NATIONAL_PAGES.ACTIVITIES.ART.MUSIC,
    NATIONAL_PAGES.ACTIVITIES.SCOUTS.SCOUT,
    NATIONAL_PAGES.ACTIVITIES.SCOUTS.MEJ,
    NATIONAL_PAGES.ACTIVITIES.SOCIAL,
    NATIONAL_PAGES.ACTIVITIES.SPORTS,
    NATIONAL_PAGES.ACTIVITIES.THEATRE,
    // About
    NATIONAL_PAGES.ABOUT.HISTORY,
    NATIONAL_PAGES.ABOUT.PERSONAL.FORMATION,
    NATIONAL_PAGES.ABOUT.PARTNERS,
  ],
  MEDIA: [
    // Media
    ...Object.values(NATIONAL_PAGES.MEDIA)
      .filter((value) => value !== NATIONAL_PAGES.MEDIA.GENERAL)
      .map((val) => String(val)),
    // About
    NATIONAL_PAGES.ABOUT.TOUR,
    NATIONAL_PAGES.ABOUT.PERSONAL.STAFF,
  ],
  EMAIL: [...Object.values(NATIONAL_PAGES.EMAIL).map((val) => String(val))],
  CAREER: [NATIONAL_PAGES.CAREERS],
};

export const BAC_PAGES = {
  HOME: {
    VISION: 'home/vision',
    MISSION: 'home/mission',
    WHO: 'home/who',
    ABOUT: ' home/about',
    TESTIMONIAL: 'home/testimonial',
    GALLERY: 'home/gallery',
  },
  ACADEMICS: {
    STAGES: {
      GENERAL: 'academics/stages',
      COLLEGE: 'academics/stages/college',
      ELEMENTARY: 'academics/stages/elementary',
      LYCEE: 'academics/stages/lycee',
    },
    LIBRARY: {
      GENERAL: 'academics/library',
      FR: 'academics/library/fr',
    },
  },
  NEWS: 'news',
  ACTIVITIES: {
    GENERAL: 'activities',
    ART: 'activities/art',
    SPORT: 'activities/sport',
    THEATRE: 'activities/theatre',
  },
  MEDIA: {
    GENERAL: 'media',
    PHOTO: 'media/photo',
    VIDEO: 'media/video',
    PRESS: 'media/press',
    RADIO: 'media/radio',
  },
  ALUMNI: 'alumni',
  ABOUT: {
    GENERAL: 'about',
    HISTORY: 'about/history',
    TOUR: 'about/tour',
    PERSONAL: {
      STAFF: 'about/personal/staff',
      PHOTO: 'about/personal/photo',
    },
  },
  ADMISSION: 'admisison',
  CAREERS: 'careers',
  EMAIL: {
    NEWS_LETTER: 'email/newsLetter',
    CONTACT_US: 'email/contactUs',
  },
};

export const BAC_SCHEMA_TYPES = {
  GENERAL: [
    // Home
    ...Object.values(BAC_PAGES.HOME).map((val) => String(val)),
    // Academics
    BAC_PAGES.ACADEMICS.STAGES.GENERAL,
    BAC_PAGES.ACADEMICS.LIBRARY.GENERAL,
    // Activities
    BAC_PAGES.ACTIVITIES.GENERAL,
    // Media
    BAC_PAGES.MEDIA.GENERAL,
    BAC_PAGES.ABOUT.GENERAL,
    // Admission
    BAC_PAGES.ADMISSION,
    // Careers
    BAC_PAGES.CAREERS,
  ],
  ARTICLE: [
    // Academics
    ...Object.values(BAC_PAGES.ACADEMICS.STAGES)
      .filter((value) => value !== BAC_PAGES.ACADEMICS.STAGES.GENERAL)
      .map((val) => String(val)),
    ...Object.values(BAC_PAGES.ACADEMICS.LIBRARY)
      .filter((value) => value !== BAC_PAGES.ACADEMICS.LIBRARY.GENERAL)
      .map((val) => String(val)),
    // News
    BAC_PAGES.NEWS,
    // Activities
    ...Object.values(BAC_PAGES.ACTIVITIES)
      .filter((value) => value !== BAC_PAGES.ACTIVITIES.GENERAL)
      .map((val) => String(val)),
    // Alumin
    BAC_PAGES.ALUMNI,
    // About
    BAC_PAGES.ABOUT.HISTORY,
  ],
  MEDIA: [
    // Media
    ...Object.values(BAC_PAGES.MEDIA)
      .filter((value) => value !== BAC_PAGES.MEDIA.GENERAL)
      .map((val) => String(val)),
    // About
    BAC_PAGES.ABOUT.TOUR,
    BAC_PAGES.ABOUT.PERSONAL.STAFF,
  ],
  EMAIL: [...Object.values(BAC_PAGES.EMAIL).map((val) => String(val))],
  CAREER: [BAC_PAGES.CAREERS],
};

export enum MESSAGES {
  CREATED_SUCCESS = 'created_success',
  UPDATED_SUCCESS = 'updated_success',
  DELETE_SUCCESS = 'delete_success',
  ARCHIVE_SUCCESS = 'archive_success',
  HARD_DELETE_SUCCESS = 'hard_delete_success',
  RESTORE_SUCCESS = 'restore_success',
  RESTORE_FAILED = 'restore_failed',
  OPERATION_FAILED = 'operation_failed',
  OPERATION_SUCCESS = 'operation_success',
  COLUMN_VALIDATION_FAILED = 'invlaid_column_value',
  SKIP_REQUIRED_PARAMETER = 'skip_required_parameters',
}
